<template>
  <div>
    <div class="flex items-center justify-start">
      <icon-base height="24" width="24" :icon="fileTypeIcon" />

      <document-preview-modal
        v-if="showModal"
        :item="model"
        :close="() => (showModal = false)"
      />

      <span
        :title="model.original_name"
        class="ml-4 cursor-pointer text-base text-gray-600 hover:text-gray-400"
        @click="showModal = true"
      >
        {{ model.original_name }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import { getDocumentFileType } from "@/helpers/formatting";

import DocumentPreviewModal from "./DocumentPreviewModal.vue";
import IconFileSmall from "@/components/icons/IconFileSmall.vue";
import IconDocSmall from "@/components/icons/fileTypes/IconDocSmall.vue";
import IconImgSmall from "@/components/icons/fileTypes/IconImgSmall.vue";
import IconPdfSmall from "@/components/icons/fileTypes/IconPdfSmall.vue";
import IconXlsSmall from "@/components/icons/fileTypes/IconXlsSmall.vue";

import type { Component } from "vue";

const FILE_TYPE_ICONS: Record<string, Component> = {
  img: IconImgSmall,
  pdf: IconPdfSmall,
  doc: IconDocSmall,
  xls: IconXlsSmall,
};

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const showModal = ref(false);

const fileType = computed(() => getDocumentFileType(props.model.original_name));

const fileTypeIcon = computed(() => {
  const key = props.model.mime_type.includes("image") ? "img" : fileType.value;
  return FILE_TYPE_ICONS[key] ?? IconFileSmall;
});
</script>
